import { EAmenities } from 'shared/types/coworking';

interface IAmenitiesGroups {
  key: string;
  title: string;
  amenities: EAmenities[];
}

export const amenitiesGroups: IAmenitiesGroups[] = [
  {
    key: 'commonAmenities',
    title: 'Ключевые удобства',
    amenities: [
      EAmenities.Modern,
      EAmenities.Furniture,
      EAmenities.Wifi,
      EAmenities.Internet,
      EAmenities.LegalAddress,
      EAmenities.Security,
    ],
  },
  {
    key: 'equipment',
    title: 'Оборудование',
    amenities: [EAmenities.Printer, EAmenities.Fax, EAmenities.Flipchart],
  },
  {
    key: 'food&drinks',
    title: 'Еда и напитки',
    amenities: [EAmenities.Tea, EAmenities.Fruits, EAmenities.Kitchen, EAmenities.Cafe],
  },
  {
    key: 'services',
    title: 'Услуги',
    amenities: [EAmenities.TechSupport, EAmenities.Reception, EAmenities.Cleaning],
  },
  {
    key: 'specialZones',
    title: 'Специальные зоны',
    amenities: [EAmenities.Lockers, EAmenities.PhoneBooth, EAmenities.MeetingRoom],
  },
  {
    key: 'communication',
    title: 'Общение',
    amenities: [EAmenities.RestZone, EAmenities.Events],
  },
  {
    key: 'transport',
    title: 'Транспорт',
    amenities: [EAmenities.Parking, EAmenities.BikeParking],
  },
  {
    key: 'health',
    title: 'Здоровье',
    amenities: [EAmenities.Gym],
  },
];
